import {
    Component,
    EventEmitter, Input,
    Output,
    ViewEncapsulation
} from '@angular/core';
import { CountryISO } from 'ngx-intl-tel-input';
import { Observable, Subscription } from 'rxjs/index';
import { filter, map, tap } from 'rxjs/operators';
import { AuthenticationSelectors } from '../auth/state/authentication.selectors';

const validatedCountryISO = (country: string) => Object.values(CountryISO)
            .find(iso => iso === country)
        || CountryISO.UnitedStates;

@Component({
    selector: 'country-picker-ng8',
    template: '<ngx-intl-tel-input [id]="id"' +
        ' [preferredCountries]="preferredCountries" ' +
        ' [enablePlaceholder]="true" ' +
        ' [separateDialCode] = "true" ' +
        ' [ngModelChange] = onChanges() ' +
        ' [(ngModel)]="phoneNumber" ' +
        ' [maxLength]="15" ' +
        ' [searchCountryFlag]="true"' +
        ' [selectedCountryISO]="selectedCountryISO$ | async"' +
        '></ngx-intl-tel-input>',
    encapsulation: ViewEncapsulation.None
})
export class CountryPickerComponent {

    preferredCountries: Array<CountryISO> = [CountryISO.UnitedStates, CountryISO.Denmark];
    @Output() readonly numberChange = new EventEmitter<string>();
    @Input() id = '';
    phoneNumber: any;
    number = '';
    public user$: Observable<any>;
    public selectedCountryISO$: Observable<any>;

    constructor(private authenticationSelectors: AuthenticationSelectors) {
        this.user$ = this.authenticationSelectors.selectCurrentUser();

        this.selectedCountryISO$ = this.user$.pipe(
            map(user => user.userCountry as string || CountryISO.UnitedStates),
            map(country => country.toLowerCase()), // TODO: Remove when all users converted to lower case in DB
            map(validatedCountryISO)
        );
    }

    onChanges(): void {
        if (this.phoneNumber !== null && this.phoneNumber !== undefined) {
            if (this.number === undefined) {
                this.number = '0';
            }
            // emit only if value changes
            if (this.number.indexOf(this.phoneNumber.e164Number) === -1) {
                this.number = this.phoneNumber.e164Number;
                this.numberChange.emit(this.number);
            }

        } else {
            this.numberChange.emit('');
        }

    }
}
